// After page load
$(function () {
  'use strict';

  let masonry;
  let current_filter_control = 'all';
  let filterContainer = document.querySelectorAll('[data-filter-container]');

  let copyright = function (anchor, images) {
    const instance = tippy(anchor, {
      content: document.querySelector('#tooltip').innerHTML,
      placement: 'right-start',
      allowHTML: true,
      theme: 'light',
      trigger: 'manual',
      interactive: true,
      arrow: false,
      offset: [0, 0],
      duration: [0, 800],
      zIndex: 1000,
    });

    images.forEach(img => {
      img.addEventListener('contextmenu', event => {
        event.preventDefault();

        instance.setProps({
          getReferenceClientRect: () => ({
            width: 0,
            height: 0,
            top: event.clientY,
            bottom: event.clientY,
            left: event.clientX,
            right: event.clientX,
          }),
        });

        instance.show();
        setTimeout(() => instance.hide(), 1000);
      });
    });

    document.addEventListener('scroll', event => {
      if (instance !== undefined) instance.hide();
    });
  };

  copyright(document.querySelector('.container_two_col'), document.querySelectorAll('.container_two_col img'));

  let feed = function () {
    'use strict';

    // Get post feed grid
    let grid = document.querySelector('.post-feed');
    if (!grid) return;

    // Manage image loading
    imagesLoaded(grid, function () {
      // Load image as masonry
      masonry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        stamp: '.related-title',
        hiddenStyle: { transform: 'translateY(50px)', opacity: 0 },
        visibleStyle: { transform: 'translateY(0)', opacity: 1 },
      });

      masonry.on('layoutComplete', function () {
        grid.classList.add('initialized');
      });

      masonry.layout();

      function callback(items, loadNextPage) {
        imagesLoaded(items, function (loaded) {
          masonry.appended(items);
          //masonry.layout();
          loaded.elements.forEach(function (item) {
            item.style.visibility = 'visible';
          });
          loadNextPage();

          // Recalculate filterContainer with new image and filter
          filterContainer = document.querySelectorAll('[data-filter-container]');
          filterData();
        });
      }

      // Delayed loading
      pagination(true, callback, true);
    });

    // Instanciate PhotoSwipe
    pswp('.post-feed', '.post', '.post-lightbox', '.post-caption', false);
  };

  // PhotoSwipe function
  function pswp(container, element, trigger, caption, isGallery) {
    let parseThumbnailElements = function (el) {
      let items = [],
        gridEl,
        linkEl,
        item;

      $(el)
        .find(element)
        .each(function (i, v) {
          gridEl = $(v);
          linkEl = gridEl.find(trigger);

          item = {
            src: isGallery ? gridEl.find('img').attr('src') : linkEl.attr('href'),
            w: 0,
            h: 0,
          };

          if (caption && gridEl.find(caption).length) {
            item.title = gridEl.find(caption).html();
          }

          items.push(item);
        });

      return items;
    };

    let openPhotoSwipe = function (index, galleryElement) {
      let pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);

      options = {
        closeOnScroll: false,
        history: false,
        index: index,
        shareEl: false,
        showAnimationDuration: 0,
        showHideOpacity: true,
      };

      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.listen('gettingData', function (index, item) {
        if (item.w < 1 || item.h < 1) {
          // unknown size
          let img = new Image();
          img.onload = function () {
            // will get size after load
            item.w = this.width; // set image width
            item.h = this.height; // set image height
            gallery.updateSize(true); // reinit Items
          };
          img.src = item.src; // let's download image
        }
      });
      gallery.init();
    };

    let onThumbnailsClick = function (e) {
      e.preventDefault();

      let index = $(e.target).closest(container).find(element).index($(e.target).closest(element));
      let clickedGallery = $(e.target).closest(container);

      openPhotoSwipe(index, clickedGallery[0]);
      copyright(document.querySelector('.pswp__container'), document.querySelectorAll('.pswp__item'));

      return false;
    };

    $(container).on('click', trigger, function (e) {
      onThumbnailsClick(e);
    });
  }

  // Filtering & Buttons
  let setupButtonAndFilters = function () {
    // Filtering
    [...document.querySelectorAll('button[data-filter-control]')].map(button => {
      button.addEventListener('click', event => {
        current_filter_control = event.target.dataset.filterControl;
        filterData();
      });
    });

    // Buttons
    let Buttons = document.querySelectorAll('.filter-button');
    let dropdownCheck = document.getElementById('drop');
    let dropHeader = document.querySelector('.dropHeader');
    for (let button of Buttons) {
      button.addEventListener('click', e => {
        // et = event target
        const et = e.target;
        // select current class
        const currentItems = document.querySelectorAll('.current');
        // check for the button that has current class and remove it
        if (currentItems) {
          currentItems.forEach(current => {
            current.classList.remove('current');
          });
        }
        // add current class to the clicked element
        et.classList.add('current');

        // Close dropdown if checked and change text
        if (dropdownCheck.checked) {
          dropdownCheck.checked = false;
          if (et.innerHTML === 'Tutto') dropHeader.innerHTML = 'Filtra';
          else dropHeader.innerHTML = et.innerHTML;
        }
      });
    }
  };

  // Recalculate image list
  function filterData() {
    filterContainer.forEach(function (container) {
      container.dataset.filterContainer = current_filter_control;
    });
    masonry.layout();
  }

  // Main setup
  setupButtonAndFilters();
  copyright(document.querySelector('.post'), document.querySelectorAll('.post img'));
  feed();
});
